import React, { FunctionComponent } from 'react';
import Loader from 'react-loader-spinner';
import { useApiRequestState } from '../../../../utils/api.utils';

export const Footer: FunctionComponent = () => {
  const [showLoader] = useApiRequestState('signUpUser');

  return (
    <div className="signup-page__actions">
      {!showLoader && (
        <button form="signup-form" type="submit" className="btn btn-lg green-bg signup-page__submit">
          Sign up
        </button>
      )}
      {showLoader && (
        <div className="signup-page__loader">
          <Loader type="TailSpin" color="#1bc3a7" height={30} width={30} />
        </div>
      )}
    </div>
  );
};
